export default __webpack_public_path__ + "static/media/pgmico(47).8de14b1b.png";